import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import InlineBanner, {InlineBannerActionType, InlineBannerType} from 'ui-library/banners/InlineBanner';
import MarkdownContent from 'ui-library/MarkdownContent';

import {FieldUISchemaBanner} from '../StepConfigEditorTypes';

/** @package */
export default function StepConfigEditorBanner({
  text,
  bannerType,
  supportingInfo,
  initialShowMore,
}: FieldUISchemaBanner): JSX.Element {
  return (
    <div className={css(styles.banner)}>
      <InlineBanner
        bannerType={bannerType ?? InlineBannerType.INFO}
        text={text}
        supportingInfo={supportingInfo ? <MarkdownContent content={supportingInfo} /> : null}
        action={{
          actionType: InlineBannerActionType.ACCORDION,
          initialShowMore,
        }}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  banner: {
    marginBottom: 10,
  },
});
